import React, { memo, useState, useEffect } from 'react'
import { Tooltip } from '@material-ui/core'

import TableCell from '../../commons/TableCell'
import SelectAndApply from '../../commons/SelectAndApply'
import ResultsTable from '../../ResultsTable'
import StatusSelector from 'components/commons/StatusSelector'

import { useHasOperation } from 'hooks/useHasOperation'
import { OPERACIONES_USUARIO, VALUES } from 'utils/constants'

const UserTable = ({
   isSearch,
   order,
   users,
   searchUsers,
   customActions,
   actionEdit,
   cleanCallback,
   onStatusChange,
   parametersOfSelectAndApply,
   isInternalAdmin,
   isInternalSuperAdmin,
   docTypes = []
}) => {
   const [newAvaliableRoles, setNewAvailablesRoles] = useState(null)

   const enableKey = useHasOperation(OPERACIONES_USUARIO.VER_CODIGO)
   const switchUserStatusRol = useHasOperation(OPERACIONES_USUARIO.CAMBIAR_ESTADO)

   useEffect(() => {
      if (isInternalSuperAdmin) {
         setNewAvailablesRoles(parametersOfSelectAndApply.availableRoles)
      } else {
         const newRoles = parametersOfSelectAndApply.availableRoles.filter(e => e.name !== 'SEGURIDAD USUARIOS')
         setNewAvailablesRoles(newRoles)
      }
      return () => {
         setNewAvailablesRoles(null)
      }
   }, [parametersOfSelectAndApply])

   const columns = [
      {
         title: 'TIPO DE IDENTIFICACIÓN',
         field: 'documentType',
         render: rowData => <span>{docTypes.find(p => p.value === rowData.documentType)?.description}</span>,
         align: 'center',
         sorting: false
      },
      {
         title: 'NÚMERO DE IDENTIFICACIÓN',
         field: 'documentNumber',
         align: 'center',
         sorting: false
      },
      {
         title: users.nitOnly ? 'RAZÓN SOCIAL' : 'NOMBRE',
         field: 'name',
         align: 'center',
         sorting: !!isSearch,
         customSort: () => 0,
         defaultSort: order,
         render: rowData => <TableCell text={rowData?.name} />
      },
      {
         title: 'APELLIDOS',
         field: 'lastName',
         align: 'center',
         sorting: false,
         render: rowData => <span>{rowData?.documentType === 'NI' ? 'N/A' : rowData?.lastName}</span>,
         hidden: users.nitOnly,
         render: rowData => <TableCell text={rowData?.lastName} />
      },
      {
         title: 'TIPO TERCERO',
         field: 'thirdParty.description',
         align: 'center',
         sorting: false
      },
      {
         title: 'CORREO ELECTRÓNICO',
         field: 'email',
         align: 'center',
         sorting: false
      },
      {
         title: 'NÚMERO CELULAR',
         field: 'cellphone',
         align: 'center',
         sorting: false
      },
      {
         title: 'TELÉFONO',
         field: 'telephone',
         align: 'center',
         sorting: false
      },
      {
         title: 'ENTIDAD',
         render: rowData => (
            <Tooltip title={rowData?.entityName} placement="top" arrow>
               <span>{rowData?.entityNit}</span>
            </Tooltip>
         ),
         align: 'center',
         sorting: false
      },
      {
         title: 'ADMINISTRADOR',
         field: 'adminUser',
         align: 'center',
         sorting: false,
         render: rowData => (rowData?.adminUser ? 'Si' : 'No')
      },
      {
         title: 'TIPO DE USUARIO',
         field: 'userType',
         align: 'center',
         sorting: false,
         render: rowData => (rowData?.userType === 'I' ? 'Interno' : 'Externo'),
         hidden: !isInternalAdmin
      },
      {
         title: 'ESTADO',
         field: 'thirdParty.status',
         align: 'center',
         sorting: false,
         render: rowData => (
            <StatusSelector
               selectedValue={rowData?.thirdParty?.status}
               options={VALUES.STATUS_OPTIONS}
               onChange={v => onStatusChange(v, rowData)}
               disabled={!switchUserStatusRol}
            />
         )
      },
      {
         title: 'ROL',
         field: 'roleList',
         render: rowData => (
            <SelectAndApply
               rowData={rowData}
               currentRowIdToApplyItems={rowData.id}
               previousAppliedItemsList={rowData?.thirdParty?.roleList}
               availableItemsListToApply={newAvaliableRoles}
               onApplyItemsToRowCallback={parametersOfSelectAndApply.onApplyRolesToUserCallback}
            />
         ),
         align: 'center',
         sorting: false
      },
      {
         title: 'FECHA REGISTRO',
         field: 'createdDate',
         sorting: false,
         align: 'center'
      },
      {
         title: 'USUARIO REGISTRO',
         field: 'createdBy',
         sorting: false,
         align: 'center'
      }
   ]

   return (
      <ResultsTable
         columns={columns}
         tableData={users}
         isSearch={isSearch}
         customActions={customActions}
         searchCallback={searchUsers}
         cleanCallback={cleanCallback}
         actionEdit={actionEdit}
         enableKey={enableKey}
         order={order}
      />
   )
}

export default memo(UserTable)
